import axios from "axios";
import { appConstants } from '../_constants';

var CancelToken = axios.CancelToken;
let wj_cancel ;

export const request = (path, data, method) => {  
		return axios({
			method: method,
			url: `${appConstants.WEB_SERVICE_URL}/${path}`,
			  headers: {
			   'crossDomain': true,
			   "authorization":localStorage.getItem("JWTTOKEN")
			  },
			data: data,				     
		})		
	}

export const requestForSearch = (path, data, method) => {
		wj_cancel && wj_cancel();  
		return axios({
			method: method,
			url: `${appConstants.WEB_SERVICE_URL}/${path}`,
			  headers: {
			   'crossDomain': true,
			   "authorization":localStorage.getItem("JWTTOKEN")
			  },
			data: data,
		    cancelToken: new CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            wj_cancel = c;
           // console.log("wj_cancel", wj_cancel);
          })				     
		}) 		
	}
export const postRequest = (path, data) => request(path, data, "POST")
export const postRequestSearch = (path, data) => requestForSearch(path, data, "POST")
export const putRequest = (path, data) => request(path, data, "PUT")



// WEBPACK FOOTER //
// ./src/api/helper.js